export default "__VITE_ASSET__D9iTx_h$__"